import {Component, OnInit} from '@angular/core';
import {UpdateService} from './services/update.service';
import {CognitoService} from './services/cognito.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    title = 'Nejayo Sales';
    isAuthenticated: boolean;

    constructor(
        private updateService: UpdateService,
        private router: Router,
        private cognitoService: CognitoService
    ) {
        this.isAuthenticated = false;
    }

    ngOnInit(): void {
        this.updateService.initUpdateCheck();
        this.cognitoService.isAuthenticated()
            .then((success: boolean) => {
                this.isAuthenticated = success;
            });
    }
}
